
;(function($){
    $(document).ready(function(){
      console.log('loaded', wpllSettings.settings);
        // document.body.innerHTML+="<div id=\"progress\"><dt></dt><dd></dd></div>";
        const {blaser_height:height, blaser_color:color, blaser_position:position, blaser_enable:enable} = wpllSettings?.settings;
        var pr = document.querySelector("#progress");
        if(enable === "0"){
            setVisible('#progress', false);
            return false;
        }
        const style = `height: ${height}px; background: ${color}; ${position}: 0;`
        pr.style.cssText = style;
      
        setTimeout(() => {
          pr.style.cssText = "width: 20%;"+style;
        }, 0);

        setTimeout(() => {
          pr.style.cssText = "width: 60%;"+style;
        }, 700);
        
        setTimeout(() => {
          pr.style.cssText = "width: 101%;"+style;
        }, 1500);
        
        setTimeout(() => {
          pr.style.cssText = "display: none";
        }, 2500);
    
          function setVisible(selector, visible) {
            document.querySelector(selector).style.display = visible ? 'block' : 'none';
          }
          
    })
    })(jQuery)
    
    
    
    
    
    // 	jQuery(document).ready(function($){
         
    // 	document.body.innerHTML+="<div id=\"progress\"><dt></dt><dd></dd></div>";
    // 	var pr=document.querySelector("#progress");
    // 	// setTimeout(function(){
    // 		pr.style.width="5%";
    // 	// },300);
    
    // 	let loadingExit = false;
    
    // 	// setInterval(() => {
    // 	// 	const prWidth = pr.style.width.replace('%', '');
    // 	// 	console.log('pr width', prWidth);
    
    // 	// 	pr.style.width="101%";
    // 	// }, 100);
        
        
    
    // 	setTimeout(function(){
    // 		pr.parentNode.removeChild(pr);
    // 	},2600);
    
    // 	var startTime = (new Date()).getTime();
    // 	$(window).load(function () {
    // 		var endTime = (new Date()).getTime();
    // 		var millisecondsLoading = endTime - startTime;
    // 		// Put millisecondsLoading in a hidden form field
    // 		// or Ajax it back to the server or whatever.
    
    // 		console.log('loading time', millisecondsLoading);
    // 	});
    
    // 	return false;
             
    
    // 	// $(document).ajaxStart(function() {
    // 	// //only add progress bar if added yet.
    // 	// 	if ($("#progress").length === 0) {
    // 	// 	$("head").append($("<div><dt/><dd/></div>").attr("id", "progress"));
    // 	// 	$("#progress").width((10 + Math.random() * 30) + "%");
    // 	// 	}
    // 	// });
    
    // 	// $(document).ajaxComplete(function() {
    // 	// 	$("#progress").width("101%").delay(20).fadeOut(400, function() {
    // 	// 		$(this).remove();
    // 	// 	});
    // 	// });
    // }); 


  